/**
 * FIFO Request Queue
 * Ensures requests are sent in order, but responses resolve independently
 */

let sendQueue = Promise.resolve()

export function enqueueRequest<T>(request: () => Promise<T>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    sendQueue = sendQueue.then(
      () => request().then(resolve, reject),
      () => request().then(resolve, reject)
    )
  })
}
